/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncActiveInstrumentLinks} from '../api'

export const useMutationSyncActiveInstrumentLinks = createReactQueryMutationHook('syncActiveInstrumentLinks', syncActiveInstrumentLinks)
